import React, { JSX, lazy, Suspense } from 'react';
import { ForgetPasswordProps } from './index';

const LazyForgetPassword = lazy(() => import('./index'));

const ForgetPassword = (props: ForgetPasswordProps) => (
  <Suspense fallback={null}>
    <LazyForgetPassword {...props} />
  </Suspense>
);

export default ForgetPassword;
